import { __assign } from "tslib";
import { filterNullableDropdownItems, isDropdownGroup } from '../helpers';
import { useState, useMemo } from 'react';
function match(item, searchQuery) {
    if (!item) {
        return false;
    }
    if (isDropdownGroup(item)) {
        var filteredItems = searchFilter(item.items, searchQuery);
        if (filteredItems.length > 0) {
            return __assign(__assign({}, item), { items: filteredItems });
        }
    }
    else if (typeof item.label === 'string' &&
        item.label.includes(searchQuery)) {
        return item;
    }
    return false;
}
function searchFilter(items, searchQuery) {
    if (!searchQuery) {
        return items;
    }
    return items
        .map(function (item) { return match(item, searchQuery); })
        .filter(function (item) { return !!item; });
}
// This hook does basic sanitization of items, filtering out falsy options,
// and optionally allows further filtering for search
export function useDropdownItems(items) {
    var _a = useState(''), searchQuery = _a[0], setSearchQuery = _a[1];
    var filteredItems = useMemo(function () { return searchFilter(filterNullableDropdownItems(items), searchQuery); }, [items, searchQuery]);
    return {
        filteredItems: filteredItems,
        setSearchQuery: setSearchQuery,
    };
}
//# sourceMappingURL=useDropdownItems.js.map